module.exports = __webpack_public_path__ + "static/media/bc93897a-1abb-4e87-829f-ff0fcf993781.d992ac2f.jpeg";